import { ApolloClient, HttpLink, InMemoryCache, ApolloProvider } from "@apollo/client";

const shopifyAdminApiVersion = "2026-04";

export default function AuthenthicatedApolloProvider({ children }: { children?: React.ReactNode }) {
    const client = new ApolloClient({
        link: new HttpLink({
            uri: `shopify:admin/api/${shopifyAdminApiVersion}/graphql.json`,
            headers: {
                'Content-Type': 'application/json',
            },
        }),
        cache: new InMemoryCache(),
    });
    return <ApolloProvider client={client}>{children}</ApolloProvider>;
}